var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddToCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FF6610"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.004 44.914c-11.531 0-20.91-9.383-20.91-20.914 0-11.531 9.379-20.914 20.91-20.914S44.918 12.469 44.918 24c0 11.531-9.383 20.914-20.914 20.914zm0-38.023C14.57 6.89 6.894 14.566 6.894 24c0 9.434 7.676 17.11 17.11 17.11 9.437 0 17.11-7.676 17.11-17.11S33.44 6.89 24.003 6.89zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.61 22.098h-5.704v-5.703c0-1.051-.851-1.903-1.902-1.903a1.904 1.904 0 00-1.899 1.903v5.703h-5.707A1.901 1.901 0 0014.5 24c0 1.05.852 1.902 1.898 1.902h5.707v5.703a1.9 1.9 0 003.801 0v-5.703h5.703a1.902 1.902 0 100-3.804zm0 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToCart);
export default __webpack_public_path__ + "static/media/AddToCart.2ea0f94125f02299b44d30a9443c48ad.svg";
export { ForwardRef as ReactComponent };